import {Accordion, Row, Col} from 'react-bootstrap';
import {useState, useRef} from 'react';

function IminioUserListItem({ id, userData, children, width }) {

    return (
        <>
          <Accordion className="mb-2">
            <Accordion.Item eventKey={userData.id}>
              <Accordion.Header className="iminio-list-item-header">
                  <Row id={id} className="justify-content-start align-items-center width-100">
                      <h6 className="fg-orange-dark me-3 text-7" style={{maxWidth: '10px'}}>{userData.id}</h6>
                      <Col id={`${id}-full_name`} xs={4} sm={3} md={2} lg={3} className="text-9">
                          {userData.first_name} {userData.last_name}
                      </Col>
                      <Col xs={4} md={3}>
                          <span id={`${id}-email`} className="text-9">{userData.email}</span>
                      </Col>
                      {
                        width < 900 ? '' :
                        <Col xs={0} sm={0} md={2} className="d-xs-none d-md-block">
                            <span id={`${id}-phone`} className="text-9">{userData.phone}</span>
                        </Col>
                      }
                  </Row>
              </Accordion.Header>
              <Accordion.Body className="iminio-list-item-body">
                {children}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </>
      );
}

export default IminioUserListItem